import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/auth/use-auth';
import UiLoader from '@/ui/UiLoader/UiLoader';

export default function Logout() {
  const navigate = useNavigate();
  const { logout, id_token, token, logoutLite } = useAuth();

  React.useEffect(() => {
    if (token) {
      logoutLite().finally(() => navigate('/'));
    } else {
      logout(id_token).finally(() => navigate('/'));
    }
  }, []);

  return <UiLoader />;
}
